import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Select,
  MenuItem,
  Grid,
  Button,
  Box,
  FormControl,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
// import { FETCH_ECOSSYTEM_LOADING_POPUP } from "../../../../containers/actions/types";
// import { fetchEcosystemPopup } from "../../../../containers/actions/ecosystemActions";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../common/helperFunctions/usePrevious";
import { Autocomplete } from "@material-ui/lab";
import { FETCH_ALL_SPONSOR_NETWORKS_LOADING } from "../../../../containers/actions/types";
import { fetchAllSponsorNetworks } from "../../../../containers/actions/netwrokActions";

function CreateNewNetworkPopup(props) {
  const dispatch = useDispatch();

  const {
    open,
    onClose,
    handleOpenCreateNewEcosystemScreen,
    existingSponsorFlow,
    handleChangeExistingSponsorFlow,
    selectedSponsorDetails,
    setSelectedSponsorDetails,
  } = props;

  const [ecosystemsDataPopup, setEcosystemsDataPopup] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  // const [selectedSponsorDetails, setSelectedSponsorDetails] = useState({
  //   organizationId: null,
  //   ecosystemId: null,
  // });

  const handleEcosystemAddtion = (value) => {
    handleChangeExistingSponsorFlow(value);
    if (value) {
      // Find the selected sponsor row from ecosystemsDataPopup
      const selectedRow = ecosystemsDataPopup.find(
        (item) =>
          item.country === selectedCountry?.label &&
          item.state === selectedState?.label &&
          item.sponsorName === selectedSponsor?.label
      );

      delete selectedRow.status;
      delete selectedRow.activeTab
      
      if (selectedRow) {
        handleOpenCreateNewEcosystemScreen(selectedRow);
        onClose();
      }
    } else {
      handleOpenCreateNewEcosystemScreen();
      onClose();
    }
  };

  let fetchEcosystemLoadingPopup = useSelector(
    // (state) => state?.network?.sponsorNetworkLoading
    (state) => state?.network?.sponsorNetworkLoading || []
  );

  let fetchEcosystemsDataPopup = useSelector(
    (state) => state?.network?.sponsorNetwork?.SponsorNetworks || []
  );

  let prevFetchEcosystemsDataPopup = usePrevious(fetchEcosystemsDataPopup);

  let fetchErrors = useSelector((state) =>
    state.ecosystems.fetchEcosystemsDataPopup
      ? state.ecosystems.fetchEcosystemsDataPopup
      : {
          status: "false",
          errror: "Something went wrong. Please contact Schrocken Support.",
        }
  );

  useEffect(() => {
    if (
      JSON.stringify(fetchEcosystemsDataPopup) !==
      JSON.stringify(prevFetchEcosystemsDataPopup)
    ) {
      const uniqueCountries = [
        ...new Set(fetchEcosystemsDataPopup.map((item) => item.country)),
      ].map((country) => ({ label: country }));

      setCountries(uniqueCountries);
      setEcosystemsDataPopup(fetchEcosystemsDataPopup);
    }
  }, [fetchEcosystemsDataPopup, prevFetchEcosystemsDataPopup]);

  useEffect(() => {
    if (selectedCountry) {
      const filteredStates = [
        ...new Set(
          fetchEcosystemsDataPopup
            .filter((item) => item.country === selectedCountry.label)
            .map((item) => item.state)
        ),
      ].map((state) => ({ label: state }));

      setStates(filteredStates);
    } else {
      setStates([]);
      setSelectedState(null);
    }
  }, [selectedCountry, fetchEcosystemsDataPopup]);

  // useEffect(() => {
  //   if (selectedCountry && selectedState) {
  //     const filteredSponsors = fetchEcosystemsDataPopup
  //       .filter(
  //         (item) =>
  //           item.country === selectedCountry.label &&
  //           item.state === selectedState.label
  //       )
  //       .map((item) => ({
  //         label: item.sponsorName,
  //         organizationId: item.organizationId,
  //         ecosystemId: item.ecosystemId,
  //       }));

  //     setSponsors(filteredSponsors);
  //   } else {
  //     setSponsors([]);
  //   }
  // }, [selectedCountry, selectedState, fetchEcosystemsDataPopup]);

  useEffect(() => {
    if (selectedCountry && selectedState) {
      const seenNames = new Set();
      const filteredSponsors = fetchEcosystemsDataPopup
        .filter(
          (item) =>
            item.country === selectedCountry.label &&
            item.state === selectedState.label
        )
        .reduce((acc, item) => {
          if (!seenNames.has(item.sponsorName)) {
            seenNames.add(item.sponsorName);
            acc.push({
              label: item.sponsorName,
              organizationId: item.organizationId,
              ecosystemId: item.ecosystemId,
            });
          }
          return acc;
        }, []);

      setSponsors(filteredSponsors);
    } else {
      setSponsors([]);
    }
  }, [selectedCountry, selectedState, fetchEcosystemsDataPopup]);

  const handleCountryChange = (event, value) => {
    setSelectedCountry(value);
    setSelectedState(null);
    setSelectedSponsor(null);
    setSelectedSponsorDetails({ organizationId: null, ecosystemId: null });
  };

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setSelectedSponsor(null);
    setSelectedSponsorDetails({ organizationId: null, ecosystemId: null });
  };

  const handleSponsorChange = (event, value) => {
    setSelectedSponsor(value);
    if (value) {
      const sponsor = sponsors.find((s) => s.label === value.label);
      setSelectedSponsorDetails({
        organizationId: sponsor.organizationId,
        ecosystemId: sponsor.ecosystemId,
      });
    } else {
      setSelectedSponsorDetails({ organizationId: null, ecosystemId: null });
    }
  };

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: "All",
        statusFilter: "All",
        networkTypeIDFilter: "All",
        // status: "",
        // pageNumber: "",
        // pageSize: "",
        // getAllEcosystems: true,
      })
    );
  }, []);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "black",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "red")}
          onMouseOut={(e) => (e.currentTarget.style.color = "black")}
          onClick={onClose}
        >
          <Typography
            variant="h6"
            style={{
              color: "inherit",
              marginRight: "4px",
            }}
          >
            Close
          </Typography>
          <CloseIcon
            onClick={onClose}
            style={{ color: "inherit", marginTop: "4px" }}
          />
        </Box>
      </DialogTitle>

      {fetchEcosystemLoadingPopup === true ? (
        <DialogContent>
          <div
            style={{
              height: "350px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress thickness="7" />
          </div>
        </DialogContent>
      ) : fetchErrors.status === false ? (
        <Grid
          style={{
            height: "350px",
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "120px",
          }}
        >
          <Typography
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            {fetchErrors.errorDescription}
          </Typography>
        </Grid>
      ) : (
        <DialogContent style={{ paddingLeft: "60px", paddingRight: "60px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Please check if Sponsor is already in the list
              </Typography>
            </Grid>

            <Grid item xs={6} style={{ marginBottom: "15px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Select Country
                <span style={{ fontWeight: "bold", color: "red" }}> *</span>
              </Typography>

              <Autocomplete
                size="small"
                options={countries}
                getOptionLabel={(option) => option.label}
                value={selectedCountry}
                onChange={handleCountryChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Country"
                  />
                )}
                fullWidth
                style={{ width: "90%" }}
              />
            </Grid>
            <Grid item xs={6} style={{ marginBottom: "15px" }}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: "bold", marginLeft: "20px" }}
              >
                Select State
                <span style={{ fontWeight: "bold", color: "red" }}> *</span>
              </Typography>

              <Autocomplete
                size="small"
                options={states}
                getOptionLabel={(option) => option.label}
                value={selectedState}
                onChange={handleStateChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select State"
                  />
                )}
                fullWidth
                style={{ width: "90%", marginLeft: "20px" }}
                disabled={!selectedCountry}
              />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Select Sponsor Name
                <span style={{ fontWeight: "bold", color: "red" }}> *</span>
              </Typography>

              <Autocomplete
                size="small"
                options={sponsors}
                getOptionLabel={(option) => option.label}
                value={selectedSponsor}
                onChange={handleSponsorChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Sponsor Name"
                  />
                )}
                fullWidth
                disabled={!selectedCountry || !selectedState}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ textAlign: "center", marginBottom: "12px" }}
            >
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{ borderRadius: "20px" }}
                onClick={() => handleEcosystemAddtion(true)}
                disabled={
                  !selectedCountry || !selectedState || !selectedSponsor
                }
              >
                Continue
              </Button>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ textAlign: "center", marginBottom: "15px" }}
            >
              <Typography style={{ fontSize: "12px", fontWeight: "bold" }}>
                Country/State/Sponsor Name not in the List?{" "}
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "#e36e39",
                  }}
                  onClick={() => handleEcosystemAddtion(false)}
                >
                  Click here to add new details
                </span>
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      )}
    </Dialog>
  );
}

export default CreateNewNetworkPopup;
